module.exports = __webpack_public_path__ + "static/media/logo_yalo_beneficios.065c5840.png";